/**
 * GraphQL mutation strings for the User Profile service.
 */

const CONTACT_VALUE_FRAGMENT = `
  ... on ScalarContact { val }
  ... on AddressContact {
    building unit streetNumber streetName postalDeliveryInfo
    locality region postcode country countryId
    formattedAddress addressValidation addressValidationSource
  }
`;

export const CREATE_CONTACT = `
  mutation CreateContact($input: CreateContactInput!) {
    createContact(input: $input) {
      id userId typeId rank isActive isRecovery bounced bounceCount
      contactValue { ${CONTACT_VALUE_FRAGMENT} }
    }
  }
`;

export const UPDATE_CONTACT = `
  mutation UpdateContact($id: ID!, $input: UpdateContactInput!) {
    updateContact(id: $id, input: $input) {
      id userId typeId rank isActive isRecovery bounced bounceCount
      contactValue { ${CONTACT_VALUE_FRAGMENT} }
    }
  }
`;

export const DELETE_CONTACT = `
  mutation DeleteContact($id: ID!) {
    deleteContact(id: $id)
  }
`;

export const SET_PRIMARY_CONTACT = `
  mutation SetPrimaryContact($id: ID!) {
    setPrimaryContact(id: $id) {
      id userId typeId rank
    }
  }
`;

export const UPDATE_USER_PROFILE = `
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfile(input: $input) {
      id firstName lastName fullName gender birthDate isActive entityId
    }
  }
`;

export const REORDER_CONTACTS = `
  mutation ReorderContacts($input: ReorderContactsInput!) {
    reorderContacts(input: $input) {
      id rank
    }
  }
`;
